import { render, staticRenderFns } from "./OwnControl.vue?vue&type=template&id=db820206&"
import script from "./OwnControl.vue?vue&type=script&lang=js&"
export * from "./OwnControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports